import { render, staticRenderFns } from "./SankeyEchart.vue?vue&type=template&id=676e252c&scoped=true&"
import script from "./SankeyEchart.vue?vue&type=script&lang=js&"
export * from "./SankeyEchart.vue?vue&type=script&lang=js&"
import style0 from "./SankeyEchart.vue?vue&type=style&index=0&id=676e252c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e252c",
  null
  
)

export default component.exports